// extracted by mini-css-extract-plugin
module.exports = {"table":"table-ee09415147775f13f09886886000ef74","table__title":"table__title-bd57e5ee229cdb1812fa9e5e700703b8","upload":"upload-7f5655cb1ab8a08def3cc99561a80890"};